import { render, staticRenderFns } from "./noticemanage.vue?vue&type=template&id=6d668491&"
import script from "./noticemanage.vue?vue&type=script&lang=js&"
export * from "./noticemanage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports